module.exports = __webpack_public_path__ + "img/7_173.2985a11b.png";